import React from 'react';
import PropTypes from 'prop-types';
import AcquisitionDetailTable from './AcquisitionDetailTable';
import AcquisitionVisitorWebActivity from './AcquisitionVisitorWebActivity';
import ErrorBoundary from '../reporting_utils/ErrorBoundary';
import { BadgeList, Badge } from '../reporting_utils/Badge';

function ScheduledAcquisitionDetail({ reportData, domainSettings, locationNames, groupNames }) {
  const { acquisition_detail, acquisition_visitor_web_activity, summary_pie_acquisition } =
    reportData;

  const { isAutomotiveIndustry, isTextingEnabled } = domainSettings;

  return (
    <div className='report-details-container'>
      <div className='report-details-header'>
        <div className='report-details-title'>
          <h1>Acquisition</h1>
        </div>
      </div>
      <div>
        {groupNames.length > 0 ? (
          <BadgeList title='Selected groups' maxLength={3}>
            {groupNames.map((name) => (
              <Badge label={name} key={name} />
            ))}
          </BadgeList>
        ) : null}
        {locationNames.length > 0 ? (
          <BadgeList title='Selected locations' maxLength={3}>
            {locationNames.map((name) => (
              <Badge label={name} key={name} />
            ))}
          </BadgeList>
        ) : null}
      </div>
      <ErrorBoundary>
        <div className='row'>
          <AcquisitionVisitorWebActivity
            chartData={acquisition_visitor_web_activity}
            pieData={summary_pie_acquisition}
          />
        </div>
        <AcquisitionDetailTable
          isAutomotiveIndustry={isAutomotiveIndustry}
          isTextingEnabled={isTextingEnabled}
          tableData={acquisition_detail}
        />
      </ErrorBoundary>
    </div>
  );
}

ScheduledAcquisitionDetail.propTypes = {
  reportData: PropTypes.exact({
    acquisition_detail: PropTypes.array.isRequired,
    acquisition_visitor_web_activity: PropTypes.array.isRequired,
    summary_pie_acquisition: PropTypes.array.isRequired,
  }).isRequired,
  domainSettings: PropTypes.exact({
    isAutomotiveIndustry: PropTypes.bool.isRequired,
    isTextingEnabled: PropTypes.bool.isRequired,
  }).isRequired,
  locationNames: PropTypes.array.isRequired,
  groupNames: PropTypes.array.isRequired,
};

export default ScheduledAcquisitionDetail;
